<template>
    <div>
        <span class="el-icon-plus" @click="showdialog = true">添加标签</span>
        <el-dialog
            title="添加标签"
            :visible.sync="showdialog"
            width="800px"
            v-dialogDrag
            append-to-body>
            <div class="base-warp">
                <div class="head">
                    <div class="title">点击标签添加（再次点击取消选择），或者自定义标签，点击添加按钮添加</div>
                </div>
                <el-form label-width="120px" :inline="false" size="mini">
                    <el-form-item label="自定义标签">
                        <div class="flex-box">
                            <div class="input-box">
                                <el-input v-model="word" maxlength="6" placeholder="在这里输入自定义的标签" clearable></el-input>
                            </div>
                            <el-button type="primary" size="mini" @click="add" plain>添加</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="标签列表">
                        <div class="tags">
                            <div class="tag" :class="{active: checkTags.indexOf(tag)>-1}" v-for="(tag, index) in tags" :key="index" @click="addtag(tag)">{{tag}}</div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="save">保存</el-button>
                        <el-button @click="showdialog = false">取消</el-button>
                    </el-form-item>
                </el-form>
                
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'PorjectTags',
    data() {
        return {
            showdialog: false,
            tags: [],
            word: '',
            checkTags: [],
        }
    },
    props: {
        propTags: {
            type: Array,
        },
    },
    mounted () {
        if (this.propTags){
            if(this.propTags.length>0){
                for(var tag of this.propTags){
                    if (this.tags.indexOf(tag)==-1){
                        this.tags.push(tag)
                    }
                    if (this.checkTags.indexOf(tag) == -1){
                        this.checkTags.push(tag)
                    }
                }
            }
        }
        this.getTags();
    },
    methods: {
        getTags() {
            this.$api.getTags('').then(
                data=>{
                    var arr = [];
                    if (data.length>0){
                        for (var tag of data){
                            arr.push(tag.tag)
                        }
                    }
                    this.tags = arr;
                }
            )
        },
        addtag(tag) {
            var index = this.checkTags.indexOf(tag);
            if(index>-1){
                this.checkTags.splice(index, 1);
                return;
            }
            this.checkTags.push(tag);
        },
        save() {
            this.$emit('getTags', this.checkTags);
            this.showdialog = false;
        },
        add() {
            var tag = this.word;
            var index = this.checkTags.indexOf(tag);
            if (index>-1){
                this.$message.error('标签已存在，不需要重复添加');
                return;
            }
            this.checkTags.push(tag);
            this.tags.push(tag);
        },
    },
}
</script>

<style lang="scss" scoped>
.el-icon-plus{
    cursor: pointer;
}
.base-warp{
    .head{
        margin-bottom: 10px;
        .title{
            line-height: 40px;
        }
    }
    .tags{
        .tag.active{
            background: #e6a23c;
            color: #fff;
        }
        .tag{
            cursor: pointer;
            line-height: 24px;
        }
    }
}
</style>